import { c as _c } from "react/compiler-runtime";
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import * as React from 'react';
type ClassName = Pick<React.HTMLAttributes<HTMLDivElement>, 'className'>;
type Size = 'size-1' | 'size-2' | 'size-4' | 'size-6';
type Color = 'border-border-divider' | 'border-border-brand-primary';
interface Props extends ClassName {
  isLoading?: boolean;
  noLoader?: boolean;
  children?: React.ReactNode;
  fullWidth?: boolean;
  size?: Size;
}
export const CircularLoader = t0 => {
  const $ = _c(5);
  const {
    size,
    color: t1
  } = t0;
  const color = t1 === undefined ? "border-border-divider" : t1;
  const t2 = `${color} border-t-transparent`;
  let t3;
  if ($[0] !== size || $[1] !== t2) {
    t3 = cn("animate-spin rounded-full border-2 border-solid", size, t2);
    $[0] = size;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export const Processing = t0 => {
  const $ = _c(16);
  const {
    isLoading: t1,
    noLoader: t2,
    fullWidth: t3,
    size: t4,
    children,
    className
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const noLoader = t2 === undefined ? false : t2;
  const fullWidth = t3 === undefined ? false : t3;
  const size = t4 === undefined ? "size-6" : t4;
  const t5 = fullWidth && "w-full";
  let t6;
  if ($[0] !== t5) {
    t6 = cn("relative", t5);
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = isLoading ? "pointer-events-none opacity-25" : "opacity-100";
  const t8 = className && className;
  let t9;
  if ($[2] !== t7 || $[3] !== t8) {
    t9 = cn(t7, t8);
    $[2] = t7;
    $[3] = t8;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== children || $[6] !== t9) {
    t10 = <div className={t9}>{children}</div>;
    $[5] = children;
    $[6] = t9;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== isLoading || $[9] !== noLoader || $[10] !== size) {
    t11 = isLoading && <div className="absolute inset-0 flex items-center justify-center">{!noLoader && <CircularLoader size={size} />}</div>;
    $[8] = isLoading;
    $[9] = noLoader;
    $[10] = size;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10 || $[13] !== t11 || $[14] !== t6) {
    t12 = <div className={t6}>{t10}{t11}</div>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t6;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  return t12;
};
export default Processing;